import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { InsuranceDetailsGrid } from '../components/insuranceDetailsGrid';

const LOAN_PARAM = ':loanId';

export const getInsuranceDetailsRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    insurance: (loanId?: string) => ({
      path: `${basePath}/insurance/insurance-details/${LOAN_PARAM}`,
      url: `${baseUrl}/insurance/insurance-details/${loanId}`,
      documentTitle: `Insurance Details`,
    }),
  };
};

export const getInsuranceDetailsRoutes = (basePath: string, baseUrl: string) => {
  const config = getInsuranceDetailsRoutesConfig(basePath, baseUrl);
  return {
    insuranceAgentDashboard: (
      <Route exact path={config.insurance().path}>
        <Page routeDefinition={config.insurance()}>
          <InsuranceDetailsGrid />
        </Page>
      </Route>
    ),
  };
};
